import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_BLOG_POSTS = 'FETCH_BLOG_POSTS'
export const RECEIVE_BLOG_POSTS = 'RECEIVE_BLOG_POSTS'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_BLOG_POSTS,
	receive: RECEIVE_BLOG_POSTS
}

const url = 'https://blog.rates.bg/wp-json/wp/v2/posts'

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchPosts = () => fetch('blogPosts', url, actionTypes, { isFullLink: true }, { per_page: 5 })
